import { Indicator } from '@/components/atoms/Indicator/Indicator';
import { Range } from '@/lib/schema/shared/types';
import { FC } from 'react';
import { VDPChargingCardWrapper } from '../VDPChargingCardWrapper/VDPChargingCardWrapper';

interface VDPChargingDrivingRangeCardProps {
  rangeInfo: Range;
  fuelType: string;
}

export const VDPChargingDrivingRangeCard: FC<
  VDPChargingDrivingRangeCardProps
> = ({ rangeInfo, fuelType }) => {
  const upper = fuelType === 'Electric' ? 500 : 50;
  const lower = fuelType === 'Electric' ? 70 : 0;
  const range = rangeInfo.value;
  const percentage = Math.min(
    Math.max(0, ((range - lower) / (upper - lower)) * 100),
    100
  );

  return (
    <VDPChargingCardWrapper
      title={fuelType === 'Electric' ? 'Driving Range' : 'Electric Only Range'}
      value={`${rangeInfo.value} ${rangeInfo.unit}`}
      subtitle={'How far can you go on one charge.'}
      content={
        <div className="relative flex w-full flex-col">
          <div className="flex w-full px-l">
            <div
              className="flex w-full justify-end"
              style={{ width: `${percentage}%` }}
            >
              <div className="flex translate-x-[50%] transform justify-end">
                <Indicator title={`${rangeInfo.value} ${rangeInfo.unit}`} />
              </div>
            </div>
          </div>
          <div className="flex h-s w-full rounded-full bg-gradient-to-l from-priceChart-start via-priceChart-mid to-priceChart-end"></div>
          <div className="pt-xs text-badgeAlert text-neutral-600">
            The average range for {fuelType === 'Electric' ? 'EVs' : 'PHEVs'} is
            around {(upper + lower) / 2}mi
          </div>
        </div>
      }
    />
  );
};
